import {SHEET_SET} from '../actions/types';

type InitialStateType = {
  sheetId: 'nationalCardRejected' | 'nationalCardPending' | '';
  sheetProps: any;
};

const INITIAL_STATE: InitialStateType = {
  sheetId: '',
  sheetProps: {},
};

const SheetReducer = (
  state = INITIAL_STATE,
  action: {type: String; payload: any},
) => {
  switch (action.type) {
    case SHEET_SET:
      return {
        ...state,
        ...action?.payload,
      };
    default:
      return state;
  }
};

export default SheetReducer;
